module.exports = {
  actionLog: (Api, $stateParams) ->
    (params) ->
      query =
        offset: params.offset
        limit: params.limit

      if $stateParams.projectId
        query['project'] = $stateParams.projectId
      else
        query['entity'] = $stateParams.entityId

      return Api.ActionLog.query(query).$promise

  subject: ($stateParams, Api) ->
    if $stateParams.projectId
      return Api.Project.get(id: $stateParams.projectId).$promise
    else
      return Api.Entity.get(id: $stateParams.entityId).$promise
}
